<template>
    <div class="my-4 w-full max-w-5xl px-8 py-4 border-l-8 no-last-margin tight-p border-red-700 text-red-900 bg-red-100">
        <span v-if="block.Heading"
              class="block font-bold text-2xl xl:text-3xl mb-2 text-red-700">
            {{ block.Heading }}
        </span>
        <div class="whitespace-pre-wrap" v-html="block.Message"></div>
    </div>
</template>

<script>
    export default {
        name: "NegativeAlert",
        data() {
            return {
                block: {
                    Heading: 'This is an alert',
                    Message: 'This is an important message that has been placed into a single alert to stand out and draw attention to it.'
                }
            }
        }
    };
</script>